import { formatUnits } from "viem"

import type { WeiValue } from "@/domains/core"

export type WeiReturnObject = WeiValue & { value: string }
/**
 * now returns a WeiValue compatible object
 * @param wei
 * @param decimals
 * @returns  WeiValue & Units
 */
export const makeWeiReturnObject = (wei: bigint, decimals: number): WeiReturnObject => {
  const internalWei = wei ?? BigInt(0)
  const value = internalWei > 0n ? formatUnits(internalWei, decimals) : "0"
  return { wei: internalWei, value, decimals }
}
